import { notification } from "antd";
import Card from "antd/es/card/Card";
import DiscountCodes from "entities/DiscountCodes";
import { isEmpty } from "lodash";
import { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { MdAdd } from "react-icons/md";
import Header from "shared/components/Header";
import Search from "shared/components/Input";
import { useMutation } from "shared/hooks/useApi";
import { NAME_SPACES } from "shared/locales/constants";
import {
  CREATE_DISCOUNT_CODE,
  UPDATE_DISCOUNT_CODE,
} from "utils/api/graphql/mutations/discount-codes";
import { DISCOUNT_CODES } from "utils/api/graphql/queries/discount-codes";
import { resolveApiErrorMessage } from "utils/helpers/graphql-errors";
import Create from "../Create";
import Detail from "../Detail";
import View from "./View";

const List = () => {
  const { t } = useTranslation(NAME_SPACES.PRIVATE.ADMIN.DISCOUNT_CODE);
  const { t: tErrors } = useTranslation(NAME_SPACES.ERRORS);
  const LIST = t("LIST", { returnObjects: true });
  const apiErrorMessages = useMemo(
    () => tErrors("API", { returnObjects: true }),
    [tErrors],
  );
  const [pagination, setPagination] = useState({});
  const [search, setSearch] = useState("");
  const [openCreate, setOpenCreate] = useState(false);
  const [openDetail, setOpenDetail] = useState({});

  const onError = (error) => {
    notification.error({
      message: resolveApiErrorMessage(error, apiErrorMessages, {
        duplicateKeyMessageKey: "DISCOUNT_CODE_DUPLICATE",
      }),
    });
  };

  const [addDiscountCode] = useMutation(CREATE_DISCOUNT_CODE, {
    refetchQueries: [
      {
        query: DISCOUNT_CODES,
        awaitRefetchQueries: true,
      },
    ],
    onCompleted: () => {
      setOpenCreate(false);
    },
    onError,
  });

  const [updateDiscountCode] = useMutation(UPDATE_DISCOUNT_CODE, {
    refetchQueries: [
      {
        query: DISCOUNT_CODES,
        awaitRefetchQueries: true,
      },
    ],
    onCompleted: () => {
      setOpenDetail({});
    },
    onError,
  });

  const filter = {
    like: isEmpty(search)
      ? undefined
      : {
          OR: [{ code: `%${search}%` }, { label: `%${search}%` }],
        },
  };

  const buttons = [
    {
      icon: <MdAdd size={24} />,
      text: LIST.HEADER.SAVE,
      onClick: () => setOpenCreate(true),
    },
  ];

  return (
    <>
      <Header title={LIST.HEADER.TITLE} actions={buttons} />
      <Card type="simple">
        <div className="m-bottom-20 grid--4">
          <Search
            placeholder={LIST.SEARCH}
            type="search"
            onChange={({ target: { value } }) => {
              setPagination((prev) => ({ ...prev, skip: 0 }));
              setSearch(value);
            }}
          />
        </div>
        <DiscountCodes
          View={View}
          filter={{ ...filter, ...pagination }}
          setValues={setPagination}
          skip={pagination.skip || 0}
          NoData={View}
          setOpenDetail={setOpenDetail}
        />
        {openCreate && (
          <Create
            openCreate={openCreate}
            addDiscountCode={addDiscountCode}
            setOpenCreate={setOpenCreate}
          />
        )}
        {!isEmpty(openDetail) && (
          <Detail
            openDetail={openDetail}
            updateDiscountCode={updateDiscountCode}
            setOpenDetail={setOpenDetail}
          />
        )}
      </Card>
    </>
  );
};

export default List;
